function cart_reducer(state , action){

  switch(action.type){
    
    // case "ADD_TO_CART":
    //     const {singleCourse} = action.payload;
    //     const singlecourseobj = singleCourse[0]; 
    //       let cartcourse;
          
    //   cartcourse = {
    //         id:singlecourseobj.CourseMaster_id,
    //         image : singlecourseobj.CourseMaster_tumbimage,
    //         title:singlecourseobj.CourseMaster_title,
    //         price:singlecourseobj.CourseMaster_fee,
    //         quantity: 1,
    //   }
    //    let existingcourse = state.cart.find((curcourse)=> curcourse.id  == cartcourse.id);
    //       console.log( "exist",existingcourse);
    //    if(existingcourse){
    //        let updatecourse = state.cart.map((curcourse)=>{
    //             if(curcourse.id ==  cartcourse.id){
    //                 let newquantity = curcourse.quantity + 1 ;

    //                 return{
    //                     ...curcourse,
    //                      quantity : newquantity,
    //                  }
    //             }               
    //             else{
    //                 return curcourse;
    //             }
    //        })
    //        return {
    //         ...state,
    //         cart : updatecourse,
    //        }
    //    }
    //     else{
    //     return{
    //         ...state,
    //         cart : [...state.cart , cartcourse],
    //     }
    // }
        // case "REMOVE_CART_ITEM":
        // //     let  id = action.payload;
        // //     let updatedcart = state.cart.filter((curcart)=>curcart.id !== id
        // //     )
        // //     console.log( " update cart ",updatedcart);
        // //  return{
        // //      ...state,
        // //      cart : updatedcart,





//   case "SET_DECREASE": {
//     const DECREASE_id = action.payload;
//     const updatedCart = state.cart.map((curcourse) => {
//         if (curcourse.id === DECREASE_id) {
//             return {
//                 ...curcourse,
//                 quantity: curcourse.quantity > 1 ? curcourse.quantity - 1 : 1,
//             };
//         }
//         return curcourse;
//     });

//     return {
//         ...state,
//         cart: updatedCart,
//     };
// }

// case "SET_INCRESE": {
//     const DECREASE_id = action.payload;
//     const updatedCart = state.cart.map((curcourse) => {
//         if (curcourse.id === DECREASE_id) {
//             return {
//                 ...curcourse,
//                 quantity:  curcourse.quantity +  1 ,
//             };
//         }
//         return curcourse;
//     });

//     return {
//         ...state,
//         cart: updatedCart,
//     };
// }
    // case "CLEAR_CART" :
    //     return {
    //         ...state,
    //         cart : [],
    //     }
    
    //     case "CART_TOTAL_PRICE":
    //        let totalprice = state.cart.reduce((initialvalue , curelem)=>{
    //         let {price , quantity}  = curelem;
    //         initialvalue = initialvalue + (price * quantity);
    //         return initialvalue;
    //       },0);
    //       return {
    //         ...state,
    //         total_cart_price : totalprice,
    //       }
    
      case "CART_DATA":
        const data = action.payload;
        const orderTotals = data.map(item => item.ordertotal);
         
         return {
            ...state ,
            databasecartdata : action.payload,
             order_total: orderTotals[0]
         }
          default :
               return  state;
      }
}

export default cart_reducer
